import Link, {
  BlueLink,
  DangerLink,
  DeepBlueBoldLink,
  DeepBlueLink,
  EditLink,
  GreenLink,
  GreyLink,
} from '~/components/Link/Link';

export default Link;
export { GreenLink };
export { BlueLink };
export { DeepBlueLink };
export { DeepBlueBoldLink };
export { GreyLink };
export { EditLink };
export { DangerLink };
